<div class="hit-map-container">
  <div class="calendar-header">
    <div class="btn-area">
      <div class="button" (click)="moveToPreviousMonth()" style="color: black">
        <div class="btn-inner" style="margin: 0"><i class="material-icons">keyboard_arrow_left</i></div>
      </div>
    </div>
    <div class="date">     
      <div class="month">{{ currentMonth | date: 'MMMM' }}</div>
      <div class="year" *ngIf="isOtherYear()">{{ currentMonth | date: 'y' }}</div>
    </div>
    <div class="btn-area">
      <div class="button" (click)="moveToNextMonth()" style="color: black">
        <div class="btn-inner" style="margin: 0"><i class="material-icons">keyboard_arrow_right</i></div>
      </div>
    </div>
  </div>
  <div class="day-row" *ngFor="let day of days; let dayIdx = index">
    <div class="hour-cell tooltip-content" *ngFor="let hour of hours; let i = index" [id]="'cell-'+ dayIdx + i + '-box'" (mouseover)="hoverHour($event, dayIdx, i)" (mouseleave)="hoverOutHour($event, day, i)" (click)="selectHour(day, i)" [ngClass]="computedEventLevel(day, i)">
      <div class="tooltip" [id]="'cell-'+ dayIdx+ i">
        <div>{{ tooltipCellDate(day, i).date }}</div>
        <div>{{ tooltipCellDate(day, i).time }}</div>
      </div>
    </div>
  </div>
</div>